import { render, staticRenderFns } from "./ReportingList.vue?vue&type=template&id=199cb461"
import script from "./ReportingList.vue?vue&type=script&lang=js"
export * from "./ReportingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports